export default __webpack_public_path__ + "static/Inter-Medium-8e95917fd5bba5572274a9ea4a3474ec.woff2";